import React, { useState, useEffect } from 'react';
import { Menu } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom";
import Icons from "components/icons";
import { Localize } from "components/service";

import './sidebar.scss';


const Sidebar = ({ appParams, setToggleSider }) => {

    let {
        selectedKeys = [ 'dashboard' ],
        openKeys = [ 'dashboard' ]
    } = appParams.activeMenu;

    const [ openSubMenu, setOpenSubMenu ] = useState(openKeys);

    useEffect(() => {
        // Check if the new selectedKeys contain child items that need parent to stay open
        const needsParentOpen = selectedKeys.some(key =>
            key === 'graphic-packings' ||
            key === 'graphic-warehouse' ||
            key === 'graphic-storage-exhibitions' ||
            key === 'graphic-storage-main'
        );

        // Also check if we're on exhibitions page but came from graphic context
        const isExhibitionsFromGraphic = selectedKeys.includes('exhibitions') &&
            window.location.search.includes('context=graphic');

        if (needsParentOpen || isExhibitionsFromGraphic)
        {
            setOpenSubMenu([ ...new Set([ ...openKeys, 'graphic-storage' ]) ]);
        } else
        {
            setOpenSubMenu(openKeys);
        }

    }, [ appParams.activeMenu, openKeys, selectedKeys ]);

    const handleMenuSelect = ({ key, keyPath }) => {
        // Keep submenu open when selecting child items
        if (keyPath.length > 1)
        {
            const parentKey = keyPath[ keyPath.length - 1 ];
            if (!openSubMenu.includes(parentKey))
            {
                setOpenSubMenu(prev => {
                    const newOpenKeys = [ ...prev, parentKey ];
                    return newOpenKeys;
                });
            } else
            {
            }
        } else
        {
        }
    };


    const items = [
        {
            key: 'exhibitions',
            label: <Link to="/exhibitions"><Icons.Events /><Localize>MENUS.Label_Exhibitions</Localize></Link>,
            onClick: () => setToggleSider(true),
        },
        {
            key: 'users',
            label: <Link to="/users"><Icons.Users /><Localize>MENUS.Label_Users</Localize></Link>,
            onClick: () => setToggleSider(true),
        },
        {
            key: 'subcontractors',
            label: <Link to="/subcontractors"><Icons.SubContractors /><Localize>MENUS.Label_Subcontractors</Localize></Link>,
            onClick: () => setToggleSider(true),
        },
        {
            key: 'graphic-storage',
            label: <span><Icons.Crafts.CollectGraphicsStroke /><Localize>MENUS.Label_GraphicWarehouse</Localize></span>,
            children: [
                {
                    key: 'graphic-storage-main',
                    label: <Link to="/graphic-storage">{ selectedKeys.includes('graphic-storage-main') && <span className="menu-arrow"><RightOutlined /></span> }<Localize>MENUS.Label_GraphicStorage</Localize></Link>,
                    className: 'graphic-menu-item',
                    onClick: () => setToggleSider(true),
                },
                {
                    key: 'graphic-packings',
                    label: <Link to="/graphic-packings">{ selectedKeys.includes('graphic-packings') && <span className="menu-arrow"><RightOutlined /></span> }<Localize>MENUS.Label_GraphicPackings</Localize></Link>,
                    className: 'graphic-menu-item',
                    onClick: () => setToggleSider(true),
                },
                {
                    key: 'graphic-warehouse',
                    label: <Link to="/graphic-warehouse">{ selectedKeys.includes('graphic-warehouse') && <span className="menu-arrow"><RightOutlined /></span> }<Localize>MENUS.Label_GraphicWarehouseOverview</Localize></Link>,
                    className: 'graphic-menu-item',
                    onClick: () => setToggleSider(true),
                },
            ]
        },
        {
            key: 'last-minute',
            label: <Link to="/last-minute"><Icons.LastMin /><Localize>MENUS.Label_LastMin</Localize></Link>,
            className: 'border-menu-item',
            onClick: () => setToggleSider(true),
            // disabled: true,
        },
    ];


    return (
        <>
            <Menu
                items={ items }
                className='sidebar-menu'
                theme="dark"
                mode="inline"
                selectedKeys={ selectedKeys }
                openKeys={ openSubMenu }
                onOpenChange={ (keys) => {
                    setOpenSubMenu(keys);
                } }
                onSelect={ handleMenuSelect }
                style={ { borderRight: 0 } }>
            </Menu>
        </>
    );
};

export default Sidebar;